module.exports = __webpack_public_path__ + "static/media/25.14c23f3e.jpg";